import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { PagerDutyIcon, PagerDutySearchResultIcon } from './icon';

export const pagerDutyConfig: ThirdPartyConfig = {
	displayName: 'PagerDuty',
	id: 'pagerduty',
	resourceType: ProductResourceTypes3P.PagerDuty,
	icon: get3PLogo(PagerDutyIcon, 'PagerDuty', 'medium'),
	searchResultIcon: get3PLogo(PagerDutySearchResultIcon, 'PagerDuty', 'large'),
	integrationAri: 'ari:cloud:platform::integration/pagerduty',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
